import type { FormatterType } from "@ext/markdown/core/edit/logic/Formatter/Formatters/typeFormats/getFormatterType";
import { Syntax } from "@ext/markdown/core/edit/logic/Formatter/Formatters/typeFormats/model/Syntax";
import type { NodeSerializerSpec } from "@ext/markdown/core/edit/logic/Prosemirror/to_markdown";
import type { Attrs } from "prosemirror-model";

// Legacy attributes are positional and a reader maps them onto `id` only, so anything else would be misread.
const getMarkupAttrs = (attrs: Attrs, formatter: FormatterType) =>
	formatter.type === Syntax.legacy
		? { id: attrs.id }
		: { ...attrs.markupAttrs, id: attrs.id, type: attrs.type, branch: attrs.branch };

const FragmentFormatter =
	(formatter: FormatterType): NodeSerializerSpec =>
	(state, node) => {
		state.write(formatter.openTag("fragment", getMarkupAttrs(node.attrs, formatter), true));
		state.closeBlock(node);
	};

export default FragmentFormatter;
